import styles from './SignedOutDashboard.less';

import React, { Component } from 'react';

import { ProfileIcon } from 'seek-style-guide/react';
import { ScreenReaderOnly } from 'seek-style-guide/react';
import SignInRegisterLink from 'SignInRegisterLink/SignInRegisterLink';

export default class SignedOutDashboard extends Component {

  render() {
    return (
      <div className={styles.root} data-automation="signedOutDashboard">
        <nav className={styles.content}>
          <ScreenReaderOnly>
            <h1>Sign in or register</h1>
          </ScreenReaderOnly>

          <ProfileIcon svgClassName={styles.iconSvg} />

          <p className={styles.prompt}>
            <SignInRegisterLink mode="signin" data-automation="dashboardSignIn">
              Sign in
            </SignInRegisterLink>
            <span>&nbsp;or&nbsp;</span>
            <SignInRegisterLink mode="register" data-automation="dashboardRegister">
              Register
            </SignInRegisterLink>
            <span>&nbsp;to see your saved searches and saved jobs on all your devices</span>
          </p>
        </nav>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./app/components/HomePage/components/Dashboard/components/SignedOutDashboard/SignedOutDashboard.js
 **/